// components/LoadingScreen.jsx
import React from "react";

export default function LoadingScreen({
  title = "Loading...",
  subtitle = "Please wait a moment",
}) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="text-center space-y-4">
        {/* Modern spinner centered */}
        <div className="flex items-center justify-center relative">
          <div className="w-20 h-20 border-4 border-indigo-200 rounded-full"></div>
          <div className="w-20 h-20 border-4 border-indigo-600 rounded-full animate-spin border-t-transparent absolute"></div>
        </div>

        {/* Dynamic text */}
        <div className="space-y-2">
          <p className="text-gray-700 font-medium animate-pulse">{title}</p>
          <p className="text-sm text-gray-500">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}
